const initialState = {
    data: [],
  };
  
  const notyReducer = (state = initialState, action) => {
    switch (action.type) {
      case 'SET_NOTY':
        return { ...state, data: action.payload };
      default:
        return state;
    }
  };
  
  export default notyReducer;